export default function (id) {
  return `query GetIQuote {
    getIQuote(crmLeadAccessToken: "${id}") {
      id
      viewableUntil
      chosenAddons
      chosenQuoteId   
      configurationId
      contact {
        email
        firstName
        lastName
        address {
          street
          houseNumber
          houseNumberAddition
          postalCode
          city
          countryCode
        }
      }
      energyConsumption
      ageOfProperty
      offerExpiryDate
      locale
      orderPlaced
      paymentStatus
      paymentPending
      quoteType
      referralCode
      updatedAt
      quotes {
        detailOverview {
          annualSavings
          annualSavingsCumulative
          annualSavingsTotal
          annualSubsidies
          batteryCapacity
          batteryDegradation
          contractPrice
          contractPriceBeforeDiscount
          contractPriceExclVAT
          contractPriceExclVATBeforeDiscount
          contractPriceExclVATBeforeDiscountWithoutAdders
          coverage
          discount
          downPaymentAmount
          energyGenerated
          energyGeneratedTotal
          energyPrice
          injectionTariff
          internalRateOfReturn
          inverterReplacementPrice
          inverterAndBatteryReplacementPrice
          invertersReplacementYearIndex
          paybackPeriodInYears
          prosumerTariff
          pvSubsidy
          remainingPrice
          batterySelfConsumption
          valueAddedTax
          valueAddedTaxBeforeDiscount
          valueAddedTaxTariffPercentage
          bareKwhRate
          directEnergyUsagePercentage
          numberOfGreenCertificatesPerMW
          greenCertificatesCost
          batterySubsidy
          nonTaxableSubtotal
          nonTaxableSubtotalBeforeDiscount
          taxableSubtotalExclVAT
          taxableSubtotalExclVATBeforeDiscount
          savingsFirstYear
          yearlyEnergyPriceIndexation
          yearlyProductionDecreaseOfPV
          addersOnlyExclVATBeforeDiscount
        }
        id
        inverterSumACPowerkVA
        termsAndConditions {
          pdfUrl  
          type
        }
        environmentalGains {
          co2
          mileage
          trees
        }
        items {
          name {
            en
            fr
            nl
          }
          category
          quantity
          warranty
          datasheet
          section
          order
        }
        addons {
          name {
            en
            fr
            nl
          }
          defaultCode
          quantity
          priceInclVAT
          priceExclVAT
        }
        panelSumPowerKwp
        stage
        snapshotSrcUrl
        environmentalGains {
          co2
          trees
          mileage
        }
      }
      isIChooser
      redesignState
    }
  }`
}
